import { createAsyncThunk } from '@reduxjs/toolkit';
import PortfolioManagerService from '@/services/PortfolioManagerService';
import normalizeChangeRequestPanelPayload from './normalizeChangeRequestPanelPayload';

const fetchChangeRequestsPanel = createAsyncThunk(
  'portfolioManager/fetchChangeRequestsPanel',
  async (
    { entityType, entityId, refetchSoft = false },
    { rejectWithValue }
  ) => {
    try {
      if (!entityType || entityId == null) {
        return rejectWithValue('missing_params');
      }
      const raw = await PortfolioManagerService.getChangeRequestPanel({
        entityType,
        entityId,
      });
      const normalized = normalizeChangeRequestPanelPayload(raw);
      return {
        ...normalized,
        _refetchSoft: Boolean(refetchSoft),
      };
    } catch (e) {
      return rejectWithValue(e.message || 'error');
    }
  }
);

export default fetchChangeRequestsPanel;
